"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OcsAgentIntegrationType = void 0;
var OcsAgentIntegrationType;
(function (OcsAgentIntegrationType) {
    OcsAgentIntegrationType["OCS"] = "OCS";
    OcsAgentIntegrationType["NEXHEALTH"] = "NEXHEALTH";
    OcsAgentIntegrationType["SIKKA"] = "SIKKA";
    OcsAgentIntegrationType["CARESTACK"] = "CARESTACK";
    OcsAgentIntegrationType["DENTICON"] = "DENTICON";
})(OcsAgentIntegrationType || (exports.OcsAgentIntegrationType = OcsAgentIntegrationType = {}));
